import { useState } from "react"
import "./User.css"
import { signOut } from "firebase/auth"
import { auth } from "../../firebase"

export default function User ({ nickname }) {

    const [displayOptions, setDisplayOptions] = useState(false)

    const handleDisplayOptions = () => {
        setDisplayOptions(!displayOptions)
    }

    const handleSignOut = (e) => {
        signOut(auth)
        window.location.reload()
    }

    return <div id="user">
        <div className="user-button" onClick={() => handleDisplayOptions()}>
            <img src={`${process.env.PUBLIC_URL}/assets/user-3296.svg`} alt="user" height="30" width="30" />
        </div>
        {displayOptions && <div className="user-options">
            <p>Logged in as <b>{nickname}</b></p>
            <div className="user-option" onClick={() => handleSignOut()}>Log out</div>
        </div>}
    </div>
}